/* Printer presets (ported from the prototype's PRINTERS). Picking a printer applies its preset. */
import type { MarginKey, PaperFam } from "./papers";

export type ColorMode = "color" | "gray" | "draft";
export interface PrinterPreset { paper?: string; color?: ColorMode; margin?: MarginKey; orient?: "portrait" | "landscape" }
export interface Printer {
  key: string;
  en: string;
  ar: string;
  icon: string;
  preset: PrinterPreset;
  /** Paper family it accepts ("any" = PDF). */
  fam: PaperFam | "any";
}

export const PRINTERS: Printer[] = [
  { key: "office", en: "Office laser / inkjet", ar: "طابعة ليزر / حبر مكتبية", icon: "printer", preset: { paper: "A4", color: "color", margin: "normal" }, fam: "page" },
  { key: "mono", en: "Monochrome laser", ar: "طابعة ليزر أحادية اللون", icon: "printer", preset: { paper: "A4", color: "gray", margin: "normal" }, fam: "page" },
  { key: "wide", en: "A3 / wide-format", ar: "طابعة A3 عريضة", icon: "layers", preset: { paper: "A3", orient: "landscape", color: "color" }, fam: "page" },
  { key: "dot", en: "Dot-matrix (continuous)", ar: "طابعة نقطية (ورق مستمر)", icon: "receipt", preset: { paper: "CF95", color: "draft", margin: "narrow" }, fam: "page" },
  { key: "th80", en: "Thermal receipt 80 mm", ar: "طابعة إيصالات حرارية 80 مم", icon: "receipt", preset: { paper: "R80", color: "gray" }, fam: "roll" },
  { key: "th58", en: "Thermal receipt 58 mm", ar: "طابعة إيصالات حرارية 58 مم", icon: "receipt", preset: { paper: "R58", color: "gray" }, fam: "roll" },
  { key: "card", en: "ID card printer", ar: "طابعة البطاقات", icon: "id-card", preset: { paper: "CR80", color: "color", margin: "none" }, fam: "card" },
  { key: "label", en: "Label printer", ar: "طابعة الملصقات", icon: "file", preset: { paper: "L105", color: "gray", margin: "none" }, fam: "label" },
  { key: "pdf", en: "Save as PDF", ar: "حفظ بصيغة PDF", icon: "download", preset: { color: "color" }, fam: "any" },
];

export const printerDef = (k: string): Printer => PRINTERS.find((p) => p.key === k) ?? PRINTERS[0];

/** Whether a printer can print a document that accepts these paper families (prototype rule). */
export function printerFits(p: Printer, docFams: PaperFam[]): boolean {
  return p.fam === "any" || docFams.includes(p.fam as PaperFam)
    || (p.fam === "label" && docFams.includes("labelsheet"))
    || (p.fam === "page" && docFams.includes("labelsheet") && (p.key === "office" || p.key === "mono"));
}
